import { StyleSheet } from 'react-native';

/** 默认配置 */
export const POPUP_FIELD_DEFAULTS = {
    // TitlePair 部分
    titleFontSize: 15,
    titleColor: '#333333',
    titleFontWeight: '500' as const,
    valueFontSize: 15,
    valueColor: '#333333',
    placeholderColor: '#C8C9CC',
    arrowColor: '#C8C9CC',

    // 弹窗部分
    confirmText: '确定',
    cancelText: '取消',
    popupBorderRadius: 16,
    popupPosition: 'bottom' as const,

    // 输入框部分
    inputPlaceholder: '请输入',
    inputMaxLength: 200,
    inputRows: 4,

    // 主题色
    primaryColor: '#FF2442',
    disabledColor: '#C8C9CC',
};

/** 创建样式 */
export const createStyles = (
    paddingConfig?: number | { horizontal?: number; vertical?: number }
) => {
    // 解析 padding 配置
    const horizontalPadding = typeof paddingConfig === 'number'
        ? paddingConfig
        : (paddingConfig?.horizontal ?? 16);
    const verticalPadding = typeof paddingConfig === 'number'
        ? 14
        : (paddingConfig?.vertical ?? 14);

    return StyleSheet.create({
        // ==================== 触发行 ====================
        container: {
            backgroundColor: '#FFFFFF',
        },
        triggerRow: {
            flexDirection: 'row',
            alignItems: 'center',
            paddingVertical: verticalPadding,
            paddingHorizontal: horizontalPadding,
        },
        triggerDisabled: {
            opacity: 0.5,
        },
        arrowIcon: {
            marginLeft: 4,
        },

        // ==================== 弹窗头部 ====================
        popupHeader: {
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            paddingHorizontal: 16,
            paddingVertical: 14,
            borderBottomWidth: StyleSheet.hairlineWidth,
            borderBottomColor: '#EBEDF0',
        },
        popupHeaderTitle: {
            fontSize: 16,
            fontWeight: '600',
            color: '#333333',
            flex: 1,
            textAlign: 'center',
        },
        popupHeaderBtn: {
            paddingHorizontal: 4,
            paddingVertical: 4,
            minWidth: 44,
        },
        popupHeaderCancelText: {
            fontSize: 14,
            color: '#969799',
        },
        popupHeaderConfirmText: {
            fontSize: 14,
            color: POPUP_FIELD_DEFAULTS.primaryColor,
            fontWeight: '500',
        },

        // ==================== 弹窗内容区 ====================
        popupContent: {
            paddingHorizontal: 16,
            paddingVertical: 16,
        },

        // ==================== 输入模式 ====================
        inputWrapper: {
            borderWidth: 1,
            borderColor: '#EBEDF0',
            borderRadius: 8,
            backgroundColor: '#F7F8FA',
            padding: 12,
        },
        inputField: {
            fontSize: 15,
            color: '#333333',
            lineHeight: 22,
            padding: 0,
            textAlignVertical: 'top',
        },
        inputCounter: {
            flexDirection: 'row',
            justifyContent: 'flex-end',
            marginTop: 8,
        },
        inputCountText: {
            fontSize: 12,
            color: '#C8C9CC',
        },
        inputCountActive: {
            color: '#333333',
        },

        // ==================== 单选模式 ====================
        radioWrapper: {
            // 由 DbRadio 自身处理样式
        },

        // ==================== 底部操作栏 ====================
        actionBar: {
            flexDirection: 'row',
            paddingHorizontal: 16,
            paddingVertical: 12,
            borderTopWidth: StyleSheet.hairlineWidth,
            borderTopColor: '#EBEDF0',
            gap: 12,
        },
        actionBtn: {
            flex: 1,
            height: 44,
            borderRadius: 22,
            justifyContent: 'center',
            alignItems: 'center',
        },
        actionBtnCancel: {
            backgroundColor: '#F7F8FA',
        },
        actionBtnConfirm: {
            backgroundColor: POPUP_FIELD_DEFAULTS.primaryColor,
        },
        actionBtnConfirmDisabled: {
            opacity: 0.5,
        },
        actionBtnCancelText: {
            fontSize: 15,
            color: '#333333',
            fontWeight: '500',
        },
        actionBtnConfirmText: {
            fontSize: 15,
            color: '#FFFFFF',
            fontWeight: '500',
        },

        // ==================== 分割线 ====================
        divider: {
            height: StyleSheet.hairlineWidth,
            backgroundColor: '#EBEDF0',
            marginLeft: 16,
        },
    });
};
